export function getDocumentStatusColor(status: string): string {
  switch (status) {
    case "UPLOADING":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300";
    case "UPLOADED":
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300";
    case "PROCESSED":
      return "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300";
    case "FAILED":
      return "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300";
  }
}

export function normalizeAttachedDatasources(
  datasources?: AgentDatasourceInput[]
): AttachedDatasource[] {
  if (!datasources?.length) {
    return [];
  }

  return datasources.map((datasource) => {
    if (typeof datasource === "string") {
      return { id: datasource, name: datasource };
    }

    return {
      id: datasource.id,
      name: datasource.name?.trim() || datasource.id,
      description: datasource.description ?? null,
      updated_at: datasource.updated_at,
    };
  });
}
